import { Link } from "react-router-dom";
import { ITableElement, ComboBoxCustom, IMenuFuction  } from "shared/components";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import { formatCurrency } from "shared/utils";
import {IRespDocuments} from 'shared/models/store/IElectronicDocuments'
import { accesRoles } from "shared/models";
import '../styles/_menuFunctions.scss';
import { Typography, Tooltip } from "@mui/material";
import { findActivityStatus } from "./findActivityStatus";
import { MenuFunctions } from "../components/MenuFunctions";
import { EResponseActivityStatus } from "shared/constants/api.enum";

export const columnsTable= ( propsMenuFuction: IMenuFuction, handleUserAssignment?: any, validateUserAuditor?: any): ITableElement<any>[] => {

  const {paramsUrl, isBillValueNotAccept, actionModalResetAudit, linkToDian, actionModalAbortDE} = propsMenuFuction

  return [
    { 
      field: 'ToId',
      headerName: '',  
      minWidth: 30,
      renderCell(params:IRespDocuments){
        return(
          <Tooltip title="Ver factura" placement="top" arrow>
            <Link to={`/consulta_documentos_electronicos/detalle_documento/${params.id}`} data-testid='link-detailed'>
              <AddCircleIcon />
            </Link>
          </Tooltip>
        )
      }
    },
    {
      field: 'documentNumber',
      headerName: 'Número de factura',
      sortable: 'ELECTRONIC_DOCUMENTS.document_number',
      minWidth: 166,
      renderCell(params:IRespDocuments) {
        const isActivityDefeated = params.activityStatus?.name === EResponseActivityStatus.FAIL;
        return (
          <span className={isActivityDefeated ? 'documentNumberDefeated' : ''}>
            {params.documentNumber}
          </span>
        )
      },
    },
    {
      field: 'issuedAt',
      headerName: 'Fecha de factura',
      sortable: 'ELECTRONIC_DOCUMENTS.issued_at',
      minWidth: 160,
      renderCell(params:IRespDocuments) {
        return (<>{dayjs(new Date(params.issuedAt)).format('DD MMMM YYYY HH:mm')}</>)
      },
    },
    {
      field: 'provider',
      headerName: 'NIT',
      sortable: 'employer_id_number',
      minWidth: 84,
      renderCell(params:IRespDocuments) {
        return (<>{params.provider.employerIdNumber}</>)
      },
    },
    {
      field: 'business_name',
      headerName: 'Razón social',
      sortable: 'business_name',
      minWidth: 190,
      renderCell(params:IRespDocuments) {
        return (<>{params.provider.name}</>)
      },
    },
    {
      field: 'totalValue',
      headerName: 'Total factura',
      sortable: 'ELECTRONIC_DOCUMENTS.total_value',
      minWidth: 130,
      renderCell(params:IRespDocuments) {
        return (<>{formatCurrency(params.totalValue)}</>)
      },
    },
    {
      field: 'stateName',
      headerName: 'Estado',
      sortable: 'ELECTRONIC_DOCUMENT_TIMELINE.LAST_TIMELINE_STAGE',
      minWidth: 190,
      renderCell(params:IRespDocuments) {
        return (<>{params.stateName}</>)
      },
    },
    {
      field: 'state',
      headerName: 'Actividad',
      sortable: 'activity',
      minWidth: 170,
      renderCell(params:IRespDocuments) {
        return (
        <>
          {
            findActivityStatus(params) ? 
              <span className={findActivityStatus(params)} data-testid='cell-activityStatus'>
                <span></span> 
                <Typography>{params.state?.name}</Typography>
              </span>
            :
              <>
                {params?.state?.name}
              </>
          }
        </>
        )
      },
    },
    {
      field: 'users',
      headerName: 'Asignado a',
      sortable: '"USERS"."USER_NAME"',
      minWidth: 180,
      rowGuard:{
        roles: accesRoles.usersSSSA
      },
      renderCell(params:IRespDocuments) {
        return (
            <ComboBoxCustom 
                handleChange={handleUserAssignment} 
                idsDoc={[params.id]} 
                currentValue={params.currentUser} 
                data={params.users!} 
                placeholder='Asignar' 
                isDisabled={params?.state?.code === "1.3" || params?.state?.code === "1.4" || validateUserAuditor()}
            />
        )
      },
    },
    {
      field: 'filingNumber',
      headerName: 'Número de radicado',
      sortable: 'ELECTRONIC_DOCUMENTS.accuse_number',
      minWidth: 176,
      renderCell(params:IRespDocuments) {
          return (<>{params.filingNumber ?? "-"}</>)
        },
    },
    {
      field: 'filedAt',
      headerName: 'Fecha de radicado',
      sortable: 'ELECTRONIC_DOCUMENTS.received_at',
      minWidth: 166,
      renderCell(params:IRespDocuments) {
          return ( <>{params.documentTimeline?.filedAt ? dayjs(new Date(params.documentTimeline?.filedAt)).format('DD MMMM YYYY HH:mm') : '-'}</> )
        },
      },
      {
        field: 'paymentAt',
        headerName: 'Fecha de pago',
        sortable: 'ELECTRONIC_DOCUMENTS.paymentAt',
        minWidth: 166,
        renderCell(params:IRespDocuments) {
          return ( <>{params.paymentAt ? params.paymentAt : '-'}</> )
        },
      },
      {
        field: 'paymentTotalValue',
        headerName: 'Valor de pago',
        sortable: 'ELECTRONIC_DOCUMENTS.paymentTotalValue',
        minWidth: 166,
        renderCell(params:IRespDocuments) {
          return ( <>{params?.paymentTotalValue ? formatCurrency(params?.paymentTotalValue) : '-'}</> )
        },
    },
    {
      field: 'paymentAttachmentUrl',
      headerName: 'Documento de pago',
      sortable: 'ELECTRONIC_DOCUMENTS.paymentAttachmentUrl',
      minWidth: 220,
      renderCell(params:IRespDocuments) {
        return ( <>{params?.paymentAttachmentUrl ? <a href={params?.paymentAttachmentUrl} target="_blank" rel="noopener noreferrer">{params?.paymentAttachmentUrl}</a> : '-'}</> )
      },
    },
    {
      field: 'paymentNumber',
      headerName: 'N° doc pago (TD)',
      minWidth: 166,
      renderCell(params:IRespDocuments) {
        return ( <>{params?.paymentNumber ?? '-'}</> )
      },
    },
    {
      field: 'actions',
      headerName: '',
      minWidth: 120,
      renderCell(params:any) {
        return (
          <MenuFunctions
            paramsUrl={paramsUrl}
            doc={params}
            actionModalAbortDE={actionModalAbortDE}
            linkToDian={linkToDian}
            actionModalResetAudit={actionModalResetAudit}
            isBillValueNotAccept={isBillValueNotAccept}
          />
        )
      },
    },
  ]
} 
    